<template>
  <main class="actions">
    <div class="container">
      <ul class="nav nav-fill" id="actionsTab" role="tablist">
        <li class="nav-item">
          <a
            class="nav-link btn-not-spinner"
            :class="{ active: !showTasksDone }"
            id="todo-tab"
            data-toggle="tab"
            role="tab"
            aria-controls="todo"
            :aria-selected="!showTasksDone ? true : false"
            @click="showTasksDone = false"
            >{{ $t("Disponibili") }}</a
          >
        </li>
        <li class="nav-item">
          <a
            class="nav-link btn-not-spinner"
            id="done-tab"
            :class="{ active: showTasksDone }"
            data-toggle="tab"
            role="tab"
            aria-controls="done"
            :aria-selected="showTasksDone ? true : false"
            @click="
              $store.dispatch('getUserActions');
              showTasksDone = true;
            "
            >{{ $t("Eseguite") }}</a
          >
        </li>
      </ul>
    </div>
    <div class="tab-content" id="actionsTabContent" v-cloak>
      <div
        class="tab-pane fade show"
        :class="{ active: !showTasksDone }"
        id="todo"
        role="tabpanel"
        aria-labelledby="todo-tab"
      >
        <action-todo-no-swipe
          v-if="this.$store.getters.getUserTasks && !showTasksDone"
          moreactions="/actions"
          :tasks.sync="this.$store.getters.getUserTasks"
          :messages.sync="this.$store.messages"
          id="actions"
          :max="12"
          :paginated="true"
        ></action-todo-no-swipe>
      </div>
      <div
        class="tab-pane fade show"
        :class="{ active: showTasksDone }"
        id="done"
        role="tabpanel"
        aria-labelledby="done-tab"
      >
        <action-done-no-swipe
          v-if="showTasksDone"
          moreactions="actions#done"
          :tasks.sync="this.$store.getters.getUserActions"
          id="actions"
          :max="12"
          :paginated="true"
        ></action-done-no-swipe>
      </div>
    </div>
  </main>
</template>
<script>
import ActionTodoNoSwipe from "./Campaign/ActionTodoNoSwipe";
import ActionDoneNoSwipe from "./Campaign/ActionDoneNoSwipe";

export default {
  name: "actions",
  data() {
    return {
      showTasksDone: false
    };
  },
  components: {
    ActionTodoNoSwipe,
    ActionDoneNoSwipe
  },
  created() {
    this.$store.commit("showSpinner");
    this.$store.dispatch("getUserTasks").then(response => {
      this.$store.commit("hideSpinner");
    });
  }
};
</script>
<style>
#todo-tab,
#done-tab {
  cursor: pointer;
}
</style>
